import React, { Component } from "react"
import { Button, Card, CardBody, Col } from "reactstrap"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { registerUser, registerUserFailed } from "../../store/auth/register/actions"
import { getDashboardData } from "../../store/dashboard/actions"
import { apiError } from "../../store/auth/login/actions"
import ReactEcharts from "echarts-for-react"
import Loader from "react-loader-spinner"
import { setUserPreference } from "../../store/auth/profile/actions"
import { withTranslation } from "react-i18next"
import Tooltip from "../../components/Common/tooltip"

class ParticipacaoFaturamentoCanal extends Component {
  constructor(props) {
    super(props)

    this.state = {
      graphType: "value",
      canais: {
        'SALAO': props.t('dashboard.lista.valorCanal.SALAO.title'),
        'BALCAO': props.t('dashboard.lista.valorCanal.BALCAO.title'),
        'DELIVERY': props.t('dashboard.lista.valorCanal.DELIVERY.title'),
        'TOTEM': props.t('dashboard.lista.valorCanal.TOTEM.title')
      }
    }
  }

  static getDerivedStateFromProps(props, current_state) {
    const canaisName = (canal) => {
      return current_state.canais[canal]
    }

    if (props.dashboardValoresPorCanal) {
      let valoresPeriodo = props.dashboardValoresPorCanal.periodo ? props.dashboardValoresPorCanal.periodo[0] : []

      const canaisObrigatorios = ['SALAO', 'BALCAO', 'DELIVERY', 'TOTEM']
      const dadosCompletos = canaisObrigatorios.map(canal => {
        const dadoExistente = valoresPeriodo.find(item => item.Canal === canal)
        return dadoExistente || {
          Canal: canal,
          Valor_Total: 0,
          Participacao_Percentual: 0
        }
      })

      const valorTotal = dadosCompletos.reduce((acc, item) => acc + (item.Valor_Total || 0), 0)

      return {
        ...props,
        ...{
          chart_options: {
            toolbox: {
              show: false
            },
            tooltip: {
              trigger: "item",
              formatter: function(params) {
                return `${params.name}<br/>${ parseFloat(params.data.valorOriginal || params.value).toLocaleString("pt-br", {
                  style: "currency",
                  currency: "BRL"
                }) } (${ params.percent }%)`
              }
            },
            legend: {
              orient: "vertical",
              left: "left",
              data: dadosCompletos.map(e => canaisName(e.Canal)),
              textStyle: {
                color: ["#74788d"]
              }
            },
            graphic: {
              type: 'text',
              left: 'left',
              top: 'middle',
              style: {
                text: `Total: ${valorTotal.toLocaleString("pt-br", {
                  style: "currency",
                  currency: "BRL"
                })}`,
                textAlign: 'left',
                fill: '#556ee6',
                fontSize: 14,
                fontWeight: 'bold'
              }
            },
            color: ['#34c38f', '#556ee6', '#f8b425', '#e74c3c'],
            series: [
              {
                name: props.t('dashboard.lista.participacaofaturamentocanal.label'),
                type: "pie",
                radius: ['40%', '70%'],
                center: ["70%", "50%"],
                data: dadosCompletos.map(e => ({
                  value: parseFloat(e.Valor_Total || 0),
                  name: canaisName(e.Canal, e.Valor_Total || 0),
                  valorOriginal: e.Valor_Total
                })),
                itemStyle: {
                  normal: {
                    label: {
                      show: window.innerWidth > 700
                    },
                    labelLine: {
                      show: window.innerWidth > 700
                    }
                  },
                  emphasis: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: "rgba(0, 0, 0, 0.5)"
                  }
                }
              }
            ]
          }
        }
      }
    }

    return props
  }

  componentDidMount() {
    this.props.getDashboardData(this.props.dashboardFilters.periodStart,
        this.props.dashboardFilters.periodEnd,
        this.props.dashboardFilters.companiesId, "valoresPorCanal")
  }

  render() {
    return (
      <React.Fragment>
        <Col xl="6">
          <Card>
            <CardBody>
              <div className="d-flex flex-wrap">
                <h4 className="card-title mb-4">
                  { this.props.t('dashboard.lista.participacaofaturamentocanal.label') }
                </h4>
                <Tooltip id='participacaofaturamentocanal' tooltip={ this.props.t('dashboard.lista.participacaofaturamentocanal.tooltip') }></Tooltip>
              </div>
              { this.props.loadingDashboardValoresPorCanal ||
              !this.state.chart_options ? (
                <div className="loader-container position-absolute">
                  <Loader
                    type="ThreeDots"
                    color="#556EE6"
                    height={ 80 }
                    width={ 80 }
                  />
                </div>
              ) : (
                <div>
                  <ReactEcharts
                    style={ { height: "300px" } }
                    option={ this.state.chart_options }
                  />
                </div>
              ) }
            </CardBody>
          </Card>
        </Col>
      </React.Fragment>
    )
  }
}

ParticipacaoFaturamentoCanal.propTypes = {
  loadingDashboardValoresPorCanal: PropTypes.any,
  dashboards: PropTypes.any,
  getDashboardData: PropTypes.func
}

const mapStatetoProps = state => {
  const {
    dashboardData,
    loadingDashboardValoresPorCanal,
    dashboardValoresPorCanal,
  } = state.Dashboard

  const {
    dashboardFilters,
    dashboards,
    preferences
  } = state.Login
  return {
    dashboardData,
    dashboardFilters,
    dashboards,
    loadingDashboardValoresPorCanal,
    dashboardValoresPorCanal,
    preferences
  }
}

export default withTranslation()(connect(mapStatetoProps, {
  registerUser,
  apiError,
  registerUserFailed,
  getDashboardData,
  setUserPreference
})(ParticipacaoFaturamentoCanal))